import { AccountTreeOutlined, ArrowDropDownRounded, ArrowRightRounded, CalendarMonthOutlined, LayersOutlined, TopicOutlined } from "@mui/icons-material";
import { Box, Dialog, DialogTitle, Grid, Tooltip, Typography } from "@mui/material";
import { Gantt, Task, EventOption, StylingOption, ViewMode, DisplayOption } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";
import moment from "moment";
import React from "react";
import { ViewSwitcher } from "./ViewSwitcher";
import { SelectItem } from "components/Input/Select/SelectItem";
import { FormProvider } from "react-hook-form";
import { useFundActionPlanGanttChart } from "../hooks/useFundActionPlan";

////image
import notfound from "assets/images/DefaultImage/not-found.png";
import TableGanttChart from "../FollowUp/Dialog/TableGanttChart";

const FundPlanGanttChart = () => {

    const { form, tasks, arrYear, open, handleClose, handleOpen, handleExpanderClick, handleChangeYear, arrActivity, setArrActivity } = useFundActionPlanGanttChart();

    const [view, setView] = React.useState<ViewMode>(ViewMode.Month);
    const [isChecked, setIsChecked] = React.useState(true);

    let columnWidth = 100;
    if (view === ViewMode.Year) {
        columnWidth = 500;
    } else if (view === ViewMode.Month) {
        columnWidth = 300;
    } else if (view === ViewMode.Week) {
        columnWidth = 250;
    }

    const TaskListTable: React.FC<{
        rowHeight: number;
        rowWidth: string;
        fontFamily: string;
        fontSize: string;
        locale: string;
        tasks: Task[];
        selectedTaskId: string;
        setSelectedTask: (taskId: string) => void;
        onExpanderClick: (task: Task) => void;
    }> = ({
        rowHeight,
        rowWidth,
        fontFamily,
        fontSize,
        locale,
        tasks,
        selectedTaskId,
        setSelectedTask,
        onExpanderClick,
    }) => {
            return (
                <div style={{ border: "1px solid #dfe1e5" }}>
                    {tasks.map((item, i) => {
                        const isProject = item.type === "project";
                        let expanderSymbol = null;
                        if (item.hideChildren === false) {
                            expanderSymbol = <ArrowDropDownRounded sx={{ fontSize: "2rem" }} />;
                        } else if (item.hideChildren === true) {
                            expanderSymbol = <ArrowRightRounded sx={{ fontSize: "2rem" }} />;
                        }

                        return (
                            <div
                                key={item.id}
                                style={{
                                    height: rowHeight,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: isProject ? "pointer" : "auto",
                                    fontFamily: "sans-serif",
                                    background: i % 2 === 0 ? "#ffffff" : "#f4f5f7",
                                    paddingLeft: isProject ? 10 : 50
                                }}
                            >
                                <Typography
                                    key={"event_" + item.id}
                                    onClick={() => onExpanderClick(item)}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        margin: 0
                                    }}
                                >
                                    {isProject ? expanderSymbol : ""}
                                    {isProject ? <AccountTreeOutlined sx={{ color: "#a468dc" }} /> : <LayersOutlined sx={{ color: "#6771dc" }} />}
                                    <Tooltip title={item.name} disableHoverListener={item.name.length < 90}>
                                        <span style={{ padding: "0 8px" }} className={item.name.length >= 90 ? "wrap-text" : ""}>{item.name}</span>
                                    </Tooltip>
                                </Typography>
                            </div>
                        );
                    })}
                </div>
            );
        };

    return (
        <FormProvider {...form}>
            <Dialog
                onClose={handleClose}
                open={open}
                id="dialog_assign_unit"
                sx={{
                    ".MuiDialog-container .MuiPaper-root": {
                        maxWidth: "none",
                    },
                }}
            >
                <DialogTitle>
                    <Typography sx={{ fontWeight: 500 }}>รายละเอียดกิจกรรม</Typography>
                </DialogTitle>
                <TableGanttChart dataActivity={arrActivity} />
            </Dialog>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={12}>
                            <SelectItem
                                name="nYear"
                                label="ปีบัญชี"
                                options={arrYear}
                                required
                                onChange={(e) => handleChangeYear(e)}
                            />
                        </Grid>
                        <Grid item xs={12} md={9} display={"flex"} justifyContent={"flex-end"}>
                            <ViewSwitcher
                                onViewModeChange={(viewMode) => setView(viewMode)}
                                onViewListChange={setIsChecked}
                                isChecked={isChecked}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {tasks.length > 0 ?
                        <Gantt
                            viewDate={new Date(new Date().getFullYear(), 0, 1)}
                            tasks={tasks}
                            locale={"th-TH"}
                            onExpanderClick={handleExpanderClick}
                            barBackgroundColor="#6771dc"
                            projectBackgroundSelectedColor={"#a468dc"}
                            barBackgroundSelectedColor="#6771dc"
                            projectProgressSelectedColor="#a468dc"
                            TaskListHeader={({ headerHeight }) => (
                                <div
                                    style={{
                                        height: headerHeight,
                                        fontWeight: "bold",
                                        width: 400,
                                        margin: 0,
                                        marginBottom: -1,
                                        display: "flex",
                                        alignItems: "center",
                                        backgroundColor: '#750102',
                                        justifyContent: 'center',
                                        color: "#fff"
                                    }}
                                >
                                    กิจกรรม
                                </div>
                            )}
                            TaskListTable={TaskListTable}
                            arrowIndent={2}
                            viewMode={view}
                            columnWidth={columnWidth}
                            TooltipContent={({ task }) => {
                                const isProject = task.type === "project";
                                let bg = isProject ? "#f8f5ff" : "#E9F3FF";
                                let border = isProject ? "#7239EA" : "#1B84FF";

                                return (
                                    <Box sx={{
                                        background: bg,
                                        padding: 2,
                                        border: `2px dashed ${border}`,
                                        borderRadius: "10px",
                                        width: "100%",
                                        maxWidth: 400
                                    }}>
                                        <Typography>
                                            <Grid container spacing={1}>
                                                <Grid item xs={1}>
                                                    <TopicOutlined />
                                                </Grid>
                                                <Grid item xs={11} fontWeight={"bold"}>
                                                    <b>:</b> {task.name}
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <CalendarMonthOutlined />
                                                </Grid>
                                                <Grid item xs={11}>
                                                    <b>:</b> {moment(task.start).add(543, "year").format("DD/MM/YYYY")} - {moment(task.end).add(543, "year").format("DD/MM/YYYY")}
                                                </Grid>
                                            </Grid>
                                        </Typography>
                                    </Box>
                                )
                            }}
                            onClick={(e) => {
                                if (e.type === "task") {
                                    handleOpen(true);
                                    setArrActivity(e['lstActivity']);
                                }
                            }}
                        // onDateChange={onTaskChange}
                        // onTaskDelete={onTaskDelete}
                        // onProgressChange={onProgressChange}
                        // onDoubleClick={onDblClick}
                        // onClick={onClick}
                        />
                        :
                        <Grid container spacing={2}>
                            <Grid item xs={12} className="flex-center">
                                <img src={notfound} alt="No items found." style={{ maxHeight: "400px" }} />
                            </Grid>
                            <Grid item xs={12} className="flex-center">
                                <h2>ไม่พบข้อมูล</h2>
                            </Grid>
                        </Grid>

                    }
                </Grid>
            </Grid>
        </FormProvider>
    )
}
export default FundPlanGanttChart;